import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { removeToast } from '../hooks/toastSlice'

const Toast = () => {
    const toasts = useSelector(state => state.toast.toasts)
    const dispatch = useDispatch()
  
    useEffect(() => {
      toasts.forEach(toast => {
        const timer = setTimeout(() => {
          dispatch(removeToast(toast.id))
        }, toast.duration)
  
        return () => clearTimeout(timer)
      })
    }, [toasts, dispatch])
  
    const handleClose = (id) => {
      dispatch(removeToast(id))
    }
  
    const getToastStyles = (type) => {
      const baseStyles = "flex items-center justify-between p-4 rounded-lg shadow-lg animate-slide-in transition-all duration-300 text-white"
      
      switch(type) {
        case 'success':
          return `${baseStyles} bg-green-500`
        case 'error':
          return `${baseStyles} bg-red-500`
        case 'warning':
          return `${baseStyles} bg-yellow-500`
        case 'info':
        default:
          return `${baseStyles} bg-gray-400`
      }
    }
  
    return (
        <div className="fixed top-5 right-5 z-50 flex flex-col gap-2 max-w-sm">
            {toasts.map(toast => (
            <div key={toast.id} className={getToastStyles(toast.type)}>
                <span className="flex-1 text-md font-medium">{toast.message}</span>
                <button 
                    className="ml-3 w-5 h-5 flex items-center justify-center text-xl hover:opacity-70 transition-opacity"
                    onClick={() => handleClose(toast.id)}
                >
                ×
                </button>
            </div>
            ))}
        </div>
    )
}

export default Toast;